import { RankEffectiveBetStatusType } from '@golden/gdk-admin'

const rankEffectiveBetStatusColor: { [key in RankEffectiveBetStatusType]: string } = {
  [RankEffectiveBetStatusType.SUCCESS]: '',
  [RankEffectiveBetStatusType.UPGRADE]: '#72d476',
  [RankEffectiveBetStatusType.DOWNGRADE]: '#ff5f5f'
}

export default rankEffectiveBetStatusColor
